import styled from 'styled-components';

import ActionButton from 'components/action-button';
import { Heading } from 'components/dialog';

export const Wrapper = styled.div``;

export const Form = styled.form`
  margin: 0 20px;
  text-align: center;
`;

export const TimRewards = styled.p`
  font-weight: ${Styles.fontWeight.heavy};
`;

export const UserPointsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const UserPoints = styled.span`
  color: ${Styles.color.primary};
  margin-left: 5px;
`;

export const LegalCopy = styled.div`
  text-align: left;
  & * {
    font-size: 0.9rem;
  }
`;

export const SendGiftButton = styled(ActionButton).attrs({ fullWidth: true })`
  margin-top: 1.5rem;
`;

export const LoaderWrapper = styled.span`
  width: 70px;
  margin-left: 8px;
`;

export const ModalBody = styled.div`
  max-width: ${Styles.layout.smallerSectionMaxWidth};
  text-align: center;
  line-height: 1.7;

  & hr {
    max-width: 400px;
    border: 0;
    height: 1px;
    background: ${Styles.color.grey.four};
  }

  & span {
    font-weight: bold;
    color: ${Styles.color.primary};
  }
`;

export const ModalHeading = styled(Heading)`
  margin: 2.5rem auto 1rem;
`;

export const ContentLoadingContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InputLabel = styled.label`
  display: flex;
  font-weight: ${Styles.fontWeight.heavy};
  text-transform: capitalize;
`;

export const MinimumPointsRequired = styled.div`
  font-size: 0.75rem;
`;
